module.exports = __webpack_public_path__ + "img/or.da13182a.png";